import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ContentLayout } from '@ibk/shared-layout';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { useBenefitMigration } from '../../hooks/useBenefitMigration';
import { useSubmitBenefitMigration } from '../../hooks/useSubmitBenefitMigration';
import { beneficiosTranslations } from '../../translations';
import styles from './BenefitMigrationPage.module.css';
import { MigrationConfirmation } from './components/MigrationConfirmation';
import { MigrationFaq } from './components/MigrationFaq';
import { MigrationIntroduction } from './components/MigrationIntroduction';
function Content() {
    const { t } = useTranslation();
    const migration = useBenefitMigration();
    const submission = useSubmitBenefitMigration();
    if (!migration.read || migration.state.kind !== 'ready')
        return null;
    return (_jsx(ContentLayout, { showSidebar: false, noBackground: true, noMaxWidth: true, className: styles.layout, breadcrumbs: [{ label: t('benefits.home.title'), href: '/beneficios' }, { label: t('benefits.migration.title') }], children: _jsx("div", { className: styles.container, "data-testid": 'migration-acceptance-page', children: _jsxs("div", { className: styles.columns, children: [_jsxs("main", { className: styles.main, children: [_jsx(MigrationIntroduction, {}), _jsx(MigrationFaq, {})] }), _jsx(MigrationConfirmation, { read: migration.read, ...submission, onSubmit: submission.submit }, JSON.stringify(migration.scope))] }) }) }));
}
export function BenefitMigrationPage() {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(Content, {}) }));
}
